module.exports = __webpack_public_path__ + "media/images/Play-Icon-d8857e6d44cb1f11f0c6e5c9786c9bdf.svg";